import React , { useState, useEffect } from 'react';
import { Layout, Divider, Checkbox } from 'antd';
import { Space } from 'antd';
import { Row, Col } from 'antd';
import { Radio } from 'antd';
import { Input, Select } from 'antd';
import { UserAddOutlined, ContactsOutlined, AimOutlined, HomeOutlined, CarryOutOutlined } from '@ant-design/icons';
import {labelStyle, dataStyle, labelStyleSmall, dataStyleSmall, boldStyle, dividerStyle} from '../Components/FormStyle'


const CustomerInfo = ({formData, setFormData}) => {

  const onChange1 = ({ target: { value } }) => {
      setFormData({ ...formData, firstName: value });

      if (formData.firstName === formData.cardFirstName) {
        setFormData((formData) => ({ ...formData, cardFirstName: value }));
      }
    };

  const onChange2 = ({ target: { value } }) => {
      setFormData({ ...formData, middleName: value });
    };

  const onChange3 = ({ target: { value } }) => {
      setFormData({ ...formData, lastName: value });

      if (formData.lastName === formData.cardLastName) {
        setFormData((formData) => ({ ...formData, cardLastName: value }));
      }
    };

  const onChange4 = ({ target: { value } }) => {
      setFormData({ ...formData, contactPhone: value });
    };

  const onChange5 = ({ target: { value } }) => {
      setFormData({ ...formData, altPhone: value });
    };

  const onChange6 = ({ target: { value } }) => {
      setFormData({ ...formData, email: value });
    };

  const onChange7 = ({ target: { value } }) => {
      // if (formData.optionsSameAddress === 1) {
      //   setFormData((formData) => ({ ...formData, billingAddress: value }));
      // }
      if (formData.billingAddress === formData.installationAddress) {
        setFormData((formData) => ({ ...formData, billingAddress: value }));
      }
      if (formData.ipPhoneAddress === formData.installationAddress) {
        setFormData((formData) => ({ ...formData, ipPhoneAddress: value }));
      }
      if (formData.cardRegistrationAddress === formData.installationAddress) {
        setFormData((formData) => ({ ...formData, cardRegistrationAddress: value }));
      }
      setFormData((formData) => ({ ...formData, installationAddress: value }));
    };

  const onChange8 = (value) => {
      setFormData({ ...formData, city: value });
    };

  const onChange9 = (value) => {
      setFormData({ ...formData, province: value });
    };

  const onChange10 = ({ target: { value } }) => {
      setFormData({ ...formData, postalCode: value });
    };

  const onChange11 = ({ target: { value } }) => {
      setFormData({ ...formData, optionsUnitType: value });
    };

  const onChange13 = ({ target: { value } }) => {
      setFormData({ ...formData, buzz: value });
    };

  // const onChange14 = ({ target: { value } }) => {
  //     if (value === 1) {
  //       setFormData((formData) => ({ ...formData, billingAddress: formData.installationAddress }));
  //     }
  //     setFormData((formData) => ({ ...formData, optionsSameAddress: value }));
  //   };

  const onChange15 = ({ target: { value } }) => {
      setFormData({ ...formData, billingAddress: value });
    };

  const onChange16 = ({ target: { value } }) => {
      setFormData((formData) => ({ ...formData, ipPhoneAddress: value }));
    };

 // Set your defaults here
  const defaultProvinceId = '172'; // Britsh Columbia
  const defaultCity = 'Vancouver';

  const [selectedProvinceId, setSelectedProvinceId] = useState(defaultProvinceId);
  const [cities, setCities] = useState([]);
  const [selectedCity, setSelectedCity] = useState(defaultCity); 
  
  const idToProvinceName = {
      176: "Newfoundland and Labrador",
      173: "Prince Edward Island",
      169: "Nova Scotia",
      170: "New Brunswick",
      168: "Quebec",
      167: "Ontario",
      171: "Manitoba",
      174: "Saskatchewan",
      175: "Alberta",
      172: "British Columbia"
    };


   // Province and City Data
  const provinceCityMap = {
        175: [
            "Airdrie", "Beaumont", "Brooks", "Calgary", "Camrose", "Chestermere",
            "Cold Lake", "Drumheller", "Edmonton", "Fort McMurray", "Fort Saskatchewan",
            "Grande Prairie", "Lacombe", "Leduc", "Lethbridge", "Lloydminster",
            "Medicine Hat", "Red Deer", "Spruce Grove", "St.â¯Albert", "Wetaskiwin"
        ],
        172: [
            "Abbotsford", "Armstrong", "Burnaby", "Campbell River", "Castlegar",
            "Chilliwack", "Colwood", "Coquitlam", "Courtenay", "Cranbrook",
            "Dawson Creek", "Delta", "Duncan", "Enderby", "Fernie",
            "Fort St.â¯John", "Grand Forks", "Greenwood", "Kamloops", "Kelowna",
            "Kimberley", "Langford", "Langley", "Maple Ridge", "Merritt",
            "Mission", "Nanaimo", "Nelson", "New Westminster", "North Vancouver",
            "Parksville", "Penticton", "Pitt Meadows", "Port Alberni",
            "Port Coquitlam", "Port Moody", "Powell River", "Prince George",
            "Prince Rupert", "Quesnel", "Revelstoke", "Richmond", "Rossland",
            "Salmon Arm", "Surrey", "Terrace", "Trail", "Vancouver",
            "Vernon", "Victoria", "West Kelowna", "White Rock", "Williams Lake"
        ],
        167: [
            "Amherstburg", "Barrie", "Belleville", "Brampton", "Brantford",
            "Brockville", "Burlington", "Cambridge", "Chatham-Kent",
            "Clarence-Rockland", "Cornwall", "Dryden", "Elliot Lake",
            "Greater Sudbury", "Guelph", "Hamilton", "Kanata", "Kenora",
            "Kingston", "Kitchener", "London", "Markham", "Mississauga",
            "Niagara Falls", "North Bay", "Oshawa", "Ottawa", "Pembroke",
            "Peterborough", "Pickering", "Port Colborne", "Richmond Hill",
            "Sarnia", "Sault Ste.â¯Marie", "St.â¯Catharines", "St.â¯Thomas",
            "Stratford", "Thunder Bay", "Timmins", "Toronto", "Vaughan",
            "Waterloo", "Welland", "Windsor", "Woodstock"
        ],
        171: [
            "Brandon", "Morden", "Portage la Prairie", "Thompson", "Winnipeg", "Steinbach", "Selkirk", "Flin Flon", "Dauphin", "Winkler"
        ],
        174: [
            "Estevan", "Melfort", "Moose Jaw", "Prince Albert", "Regina", "Saskatoon", "Swift Current", "Weyburn", "Yorkton", "Melville"
        ],
        168: [
            "MontrÃ©al", "QuÃ©bec City", "Laval", "Gatineau", "Longueuil", "Sherbrooke",
            "Saguenay", "Trois-RiviÃ¨res", "Levis", "Terrebonne"
        ],
        170: [
            "Bathurst", "Campbellton", "Dieppe", "Edmundston", "Fredericton",
            "Moncton", "Miramichi", "Saint John"
        ],
        176: [
            "Corner Brook", "Mount Pearl", "St.â¯John's"
        ],
        169: [
            "Halifax", "Sydney", "Dartmouth", "Truro", "New Glasgow"
        ],
        173: [
            "Charlottetown", "Summerside"
        ]
      };
     

// Load cities on first render
  useEffect(() => {
	const defaultCities = provinceCityMap[defaultProvinceId] || [];
    	setCities(defaultCities);
    	setSelectedCity(defaultCity || defaultCities[0] || '');
  }, []);
    

  const handleProvinceChange = (provinceId) => {
    setSelectedProvinceId(provinceId);
    const newcities = provinceCityMap[provinceId] || [];
    setCities(newcities);
    setSelectedCity(newcities[0] || ''); // auto-select first city of that province
  };

  const handleCityChange = (city) => {
    setSelectedCity(city);
  };

//when the user picks a different city or province, those values will be written into formData automatically.

 useEffect(() => {
  setFormData(prev => ({ ...prev, city: selectedCity }));
 }, [selectedCity, setFormData]);

 useEffect(() => {
  setFormData(prev => ({ ...prev, province: selectedProvinceId }));
 }, [selectedProvinceId, setFormData]);

  return (
    <Space direction="vertical" size="middle" style={{ display: 'flex' }}>
      <div/>
      <Divider orientation="left" style={dividerStyle}>
        <Space direction='horizontal' size='small' >
          <UserAddOutlined />Customer Name
        </Space>
      </Divider>

      <Row>
        <Col span={24}>
          <span style={labelStyle}>First Name:</span>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <Input onChange={onChange1} value={formData.firstName} />
        </Col>
      </Row>

      <Row>
        <Col span={24}>
          <span style={labelStyle}>Last Name:</span>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <Input onChange={onChange3} value={formData.lastName} />
        </Col>
      </Row>

      <Divider orientation="left" style={dividerStyle}>
        <Space direction='horizontal' size='small' >
          <ContactsOutlined />Contact Information
        </Space>
      </Divider>

      <Row>
        <Col span={24}>
          <span style={labelStyle}>Contact Phone:</span>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <Input
          mask={'(000) 000-0000'}
          onChange={onChange4}
          value={formData.contactPhone} />
        </Col>
      </Row>

      <Row>
        <Col span={24}>
          <span style={labelStyle}>Alt. Phone:</span>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <Input onChange={onChange5} value={formData.altPhone} />
        </Col>
      </Row>

      <Row>
        <Col span={24}>
          <span style={labelStyle}>E-mail:</span>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <Input onChange={onChange6} value={formData.email} />
        </Col>
      </Row>

      <Divider orientation="left" style={dividerStyle}>
        <Space direction='horizontal' size='small' >
          <HomeOutlined />Address Information
        </Space>
      </Divider>

      <Row>
        <Col span={24}>
          <span style={labelStyle}>Installation Address:</span>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <Input placeholder="Unit-Number Street" onChange={onChange7} value={formData.installationAddress} />
        </Col>
      </Row>

      <Row>
        <Col span={24}>
          <span style={labelStyle}>E911 Address:</span>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <Input placeholder="Unit-Number Street" onChange={onChange16} value={formData.ipPhoneAddress} />
        </Col>
      </Row>

      <Row>
        <Col span={24}>
          <span style={labelStyle}>City | Province | Postal Code:</span>
        </Col>
      </Row>
      <Row>
        <Col span={12}>
          <Select  style={{ width: "100%" }} value={selectedCity} onChange={handleCityChange}  disabled={!cities.length} placeholder="Select City">
		{cities.map((city, index) => (
                	<Select.Option key={index} value={city}>{city}</Select.Option>
                 ))}
	</Select>
        </Col>
        <Col span={4}>
          <Select style={{ width: "100%" }} value={selectedProvinceId} onChange={handleProvinceChange} placeholder="Select Province">
		{Object.entries(idToProvinceName).map(([id, name]) => (
          	<Select.Option key={id} value={id}>{name}</Select.Option>
        	))}  
	</Select>
        </Col>
        <Col span={8}>
          <Input onChange={onChange10} value={formData.postalCode}/>
        </Col>
      </Row>

      <Row justify="space-around" align="middle">
        <Col span={12}>
          <Space direction='vertical' size='small' >
            <Row>
              <Col span={24}>
                <span style={labelStyle}>Unit Type:</span>
              </Col>
            </Row>
            <Row>
              <Col span={24}>
                <Radio.Group name="optionsUnitType" defaultValue={1} onChange={onChange11} value={formData.optionsUnitType}>
                  <Radio value={1}>
                    Main
                  </Radio>
                  <Radio value={2}>
                    Basement
                  </Radio>
                  <Radio value={3}>
                    Unit
                  </Radio>
                </Radio.Group>
              </Col>
            </Row>
          </Space>
        </Col>

        <Col span={12}>
          <Space direction='vertical' size='small' >
            <Row>
              <Col span={24}>
                <span style={labelStyle}>#Buzz:</span>
              </Col>
            </Row>
            <Row>
              <Col span={24}>
              <Input
                  disabled={formData.optionsUnitType === 3 ? false : true}
                  onChange={onChange13}
                  value={formData.buzz}
                />
              </Col>
            </Row>
          </Space>
        </Col>
      </Row>

      <Row>
        <Col span={24}>
          <span style={labelStyle}>Billing Address:</span>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <Input
              onChange={onChange15}
              value={formData.billingAddress}
            />
        </Col>
      </Row>

    </Space>
  );
};

export default CustomerInfo;
